exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".notification {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 999;\n  -webkit-transition: .6s;\n  -o-transition: .6s;\n  transition: .6s;\n  visibility: visible; }\n  .notification__hidden {\n    visibility: hidden;\n    opacity: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/shared/components/Notification/index.scss
// module id = 245
// module chunks = 0